import { Box, Button, FlexBox, Link, Typography } from '@vp/swan';
import React, { useContext, useEffect } from 'react';
import './PrivacyCookiePolicy.styles.scss';
import { useCustomTracking } from '../../hooks/custom-hooks/useTracking';
import { getPrivacyPolicyLink } from '../../config/privacy-link';
import { CAContext } from '../../contexts/CAContext';

export interface IChatWindowProps {
  onPrivacyCookiePolicyAccept: () => void;
}

const PrivacyCookiePolicy: React.FC<IChatWindowProps> = ({ onPrivacyCookiePolicyAccept }) => {
  const { sendTrackingEvent } = useCustomTracking();
  const {
    chatState: { locale, chatWindow },
  } = useContext(CAContext);

  useEffect(() => {
    if (chatWindow === 'maximized') {
      sendTrackingEvent('Chatbot Viewed', 'Chatbot:Privacy', 'chatPrivacyShown');
    }
  }, [chatWindow]);
  return (
    <Box className="outerContainer" compactMode>
      <FlexBox flexDirection={'row'} gap="5" className="innerContainer" compactMode>
        <Typography fontSkin="body-small" textColor={'subtle'} style={{ flexGrow: 1 }}>
          By clicking 'Agree', you consent to VistaPrint and its chat service provider recording and using chat communications as described in the{' '}
          <Link className="policyLink" target="_blank" href={getPrivacyPolicyLink(locale)} rel="noreferrer">
            Privacy and Cookie Policy
          </Link>
          .
        </Typography>
        <Button className="agreeButton" onClick={onPrivacyCookiePolicyAccept} skin="secondary" style={{ minWidth: '72px', maxHeight: '48px' }}>
          Agree
        </Button>
      </FlexBox>
    </Box>
  );
};

export default PrivacyCookiePolicy;
